import { parseFrDate } from "@estaly/ui";

const DAY_IN_MS = 1000 * 60 * 60 * 24;

const daysBetween = (from, to) => Math.round((to - from) / DAY_IN_MS);

// Days of a challenge (dates as served by the API, dd/mm/yyyy), both ends included: total, elapsed including today,
// and remaining after today, so the last day has none left.
export const challengeDays = (challenge, now = new Date()) => {
  const start = parseFrDate(challenge.startDate);
  const total = daysBetween(start, parseFrDate(challenge.endDate)) + 1;
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const elapsed = Math.min(Math.max(daysBetween(start, today) + 1, 0), total);

  return { total, elapsed, remaining: total - elapsed };
};
